declare const __APP_VERSION__: string;
declare const __APP_DESCRIPTION__: string;
declare const __APP_RELEASES__: string;

export interface ReleaseEntry {
  readonly version: string;
  readonly date: string;
  readonly changes: readonly string[];
}

export const APP_VERSION: string =
  typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "dev";

export const APP_DESCRIPTION: string =
  typeof __APP_DESCRIPTION__ !== "undefined" ? __APP_DESCRIPTION__ : "";

export const APP_RELEASES: readonly ReleaseEntry[] =
  typeof __APP_RELEASES__ !== "undefined" ? __APP_RELEASES__ as unknown as ReleaseEntry[] : [];
